module.exports = __webpack_public_path__ + "media/v2/components/Header/shared/Profile/user-237ab855e2cabc4ed418dd01a78712eb.svg";